import Image from '@atoms/Image/Image';
import { IImage } from '@models/IImage';
import SoftLoadWrapper from '@molecules/SoftLoadWrapper/SoftLoadWrapper';
import classNames from 'classnames';

interface Props {
  readonly text: string;
  readonly images?: IImage[];
}

const ProductIntroWithLogo = ({ text, images }: Props) => (
  <section className="component-padding bg-white text-black-100 dark:bg-black-100 dark:text-white">
    <SoftLoadWrapper>
      <div className="container flex flex-col items-center gap-y-10 lg:gap-y-13">
        <div className="lg:grid lg:grid-cols-12">
          <h2
            dangerouslySetInnerHTML={{ __html: text }}
            className="h4 text-center lg:col-span-8 lg:col-start-3"
          />
        </div>

        {!!images?.length && (
          <div className="flex w-full flex-col items-center justify-center gap-5 lg:max-w-[60%] lg:flex-row lg:gap-13 xl:max-w-[50%]">
            {images.map((image) => (
              <Image
                image={image}
                classes={classNames('max-lg:w-full', {
                  'lg:w-full': images.length === 1,
                })}
                imageClasses={classNames('w-full object-contain', {
                  'max-h-16 lg:max-h-24': images.length === 1,
                  'max-h-7.5 lg:max-h-13': images.length > 1,
                })}
                key={`${image.desktop?.url}-logo`}
              />
            ))}
          </div>
        )}
      </div>
    </SoftLoadWrapper>
  </section>
);

export default ProductIntroWithLogo;
